import { html } from 'fxjs/es';

/**
 * Ness 모달 템플릿 - Body와 Footer만 있는 단순한 구조
 * @param {Object} data - 모달 데이터
 * @param {string} data.body - 모달 바디 HTML (필수)
 * @param {string} data.footer - 모달 푸터 HTML (선택사항)
 * @param {Array} data.buttons - 버튼 배열 (선택사항)
 * @param {string} data.buttons[].label - 버튼 레이블
 * @param {string} data.buttons[].class - 버튼 클래스
 * @param {string} data.buttons[].type - 버튼 타입 (confirm, check, cancel)
 * @returns {string} HTML 문자열
 */
export const nessModal = (data = {}) => {
  const { body, footer, buttons } = data;

  // 버튼들 렌더링
  const renderButtons = () => {
    if (footer) return footer; // 커스텀 푸터가 있으면 그대로 사용
    if (!buttons || buttons.length === 0) return ''; // 버튼이 없으면 푸터 없음

    return html`
      <div class="ness-modal__footer">
        ${buttons
          .map(
            (button) => html`
              <button
                class="ness-modal__button ${button.class || ''} ${button.type || 'cancel'}"
                data-button-type="${button.type || 'action'}"
              >
                ${button.label}
              </button>
            `,
          )
          .join('')}
      </div>
    `;
  };

  return html`<div class="ness-modal">
    <div class="ness-modal__body">${body || ''}</div>
    ${renderButtons()}
  </div>`;
};
